import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>This system cannot authorize this infant formula. You may need to begin a paper prior approval, documenting medical necessity.</p>

				<div className="button" onClick={() => this.startOver()}>For instructions on how to begin a paper Prior Approval request, click here. </div>
			</div>
		);
	}
}